(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desarwen-inquiry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('desarwen-inquiry')) {
    customElements.define('desarwen-inquiry', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const topic = this.querySelector('[data-topic]');
        const workshop = this.querySelector('[data-workshop]');
        const creation = this.querySelector('[data-creation]');
        if (!topic || !workshop) return;
        const params = new URLSearchParams(window.location.search);
        const localOnly = this.dataset.localOnly === 'true';
        const allowedTopics = ['atelier', 'distance', 'produit', 'commande', 'autre'];
        if (!localOnly && !topic.value) {
          const requestedTopic = params.get('demande');
          if (allowedTopics.includes(requestedTopic)) topic.value = requestedTopic;
          else if (params.has('atelier')) topic.value = 'atelier';
          else if (params.has('creation')) topic.value = 'produit';
        }
        if (!workshop.value) {
          const requestedWorkshop = params.get('atelier');
          if (Array.from(workshop.options).some(option => option.value === requestedWorkshop)) workshop.value = requestedWorkshop;
        }
        if (creation && !creation.value) {
          const requestedCreation = params.get('creation');
          const option = Array.from(creation.options).find(item => item.dataset.creationHandle === requestedCreation);
          if (option) creation.value = option.value;
        }
        const dateField = this.querySelector('[data-date]');
        const now = new Date();
        const today = [now.getFullYear(), String(now.getMonth()+1).padStart(2,'0'), String(now.getDate()).padStart(2,'0')].join('-');
        const update = () => {
          const selected = localOnly ? 'atelier' : topic.value;
          this.querySelectorAll('[data-group]').forEach(group => {
            const active = group.dataset.group.split(' ').includes(selected);
            group.hidden = !active;
            group.querySelectorAll('input,select,textarea').forEach(input => {
              input.disabled = !active;
              input.required = active && input.dataset.needed === 'true';
            });
          });
          workshop.querySelectorAll('[data-on-site]').forEach(option => {
            option.disabled = selected === 'distance';
            option.hidden = selected === 'distance';
          });
          if (workshop.selectedOptions[0] && workshop.selectedOptions[0].disabled) workshop.value = '';
          const watersNote = this.querySelector('[data-waters-note]');
          if (dateField) dateField.min = workshop.value === 'eaux-enchantees' && today < '2026-11-01' ? '2026-11-01' : today;
          if (watersNote) watersNote.hidden = selected !== 'atelier' || workshop.value !== 'eaux-enchantees';
        };
        topic.addEventListener('change', update);
        workshop.addEventListener('change', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["desarwen-pro-starters"] && !Shopify.designMode) return;
  try {
    
if (!window.desarwenStartersBound) {
  window.desarwenStartersBound = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-starter-add]');
    if (!button || button.disabled) return;
    const section = button.closest('.dsw-starters');
    const card = button.closest('article');
    const status = card.querySelector('[data-starter-status]');
    const config = JSON.parse(section.querySelector('[data-starter-config]').textContent);
    const rows = [...card.querySelectorAll('[data-starter-item]')];
    const buttons = [...section.querySelectorAll('[data-starter-add]')];
    const enabled = buttons.filter(item => !item.disabled);
    enabled.forEach(item => item.disabled = true);
    status.textContent = config.checking;
    let attempted = false;
    try {
      const response = await fetch(config.cartUrl + '.js', {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error(config.error);
      const cart = await response.json();
      for (const row of rows) {
        const existing = cart.items.filter(item => String(item.variant_id) === row.dataset.id).reduce((sum,item) => sum + item.quantity,0);
        if (row.hasAttribute('data-stock') && existing + Number(row.dataset.quantity) > Number(row.dataset.stock)) throw new Error(config.stock);
      }
      attempted = true;
      const added = await fetch(config.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:rows.map(row => ({id:Number(row.dataset.id),quantity:Number(row.dataset.quantity)}))})});
      const result = await added.json();
      if (!added.ok || result.status) throw new Error(config.error);
      window.location.assign(config.cartUrl);
    } catch(error) {
      status.textContent = error.message || config.error;
      if (!attempted) enabled.forEach(item => item.disabled = false);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
